/**
 * SoundManager
 * 
 * Centralized sound effects system for Grand Line.
 * All game sounds are loaded and played through this manager.
 */

import Phaser from 'phaser';

// ============ SOUND KEYS ============

export const SFX_KEYS = {
  // Combat
  CANNON_FIRE: 'sfx_cannon_fire',
  CANNON_FIRE_1: 'sfx_cannon_fire_1',
  CANNON_FIRE_2: 'sfx_cannon_fire_2',
  CANNON_FIRE_3: 'sfx_cannon_fire_3',
  CANNON_HIT: 'sfx_cannon_hit',
  CANNON_HIT_1: 'sfx_cannon_hit_1',
  CANNON_HIT_2: 'sfx_cannon_hit_2',
  CANNON_MISS: 'sfx_cannon_miss',
  CANNON_MISS_WATER_1: 'sfx_cannon_miss_water_1',
  CANNON_MISS_WATER_2: 'sfx_cannon_miss_water_2',
  CANNON_CRIT: 'sfx_cannon_crit',
  CANNON_CRIT_1: 'sfx_cannon_crit_1',
  CANNON_CRIT_2: 'sfx_cannon_crit_2',
  SHIP_SINKING: 'sfx_ship_sinking',
  SHIP_EXPLOSION: 'sfx_ship_explosion',
  SHIP_ON_FIRE_LOOP: 'sfx_ship_on_fire_loop',

  // Sanctum
  SANCTUM_COMBAT_1: 'sfx_sanctumcombat_1',
  SANCTUM_COMBAT_2: 'sfx_sanctumcombat_2',
  SANCTUM_COMBAT_3: 'sfx_sanctumcombat_3',
  SANCTUM_TERMINAL: 'sfx_sanctumterminal',
  
  
  
  // Fishing
  FISHING_CAST: 'sfx_fishing_cast',
  FISHING_CATCH: 'sfx_fishing_catch',
  FISHING_RARE_CATCH: 'sfx_fishing_rare_catch',
  FISHING_NO_CATCH: 'sfx_fishing_no_catch',
  
  // Economy
  COINS_GAIN: 'sfx_coins_gain',
  COINS_GAIN_1: 'sfx_coins_gain_1',
  COINS_GAIN_2: 'sfx_coins_gain_2',
  COINS_GAIN_3: 'sfx_coins_gain_3',
  COINS_SPEND: 'sfx_coins_spend',
  COINS_SPEND_1: 'sfx_coins_spend_1',
  COINS_SPEND_2: 'sfx_coins_spend_2',
  ITEM_PICKUP: 'sfx_item_pickup',
  ITEM_EQUIP: 'sfx_item_equip',
  SHOP_OPEN: 'sfx_shop_open',
  SHOP_PURCHASE: 'sfx_shop_purchase',
  
  // Progression
  LEVEL_UP: 'sfx_level_up',
  XP_GAIN: 'sfx_xp_gain',

  // Crafting
  CRAFT_1: 'sfx_craft_1',
  CRAFT_2: 'sfx_craft_2',
  CRAFT_3: 'sfx_craft_3',
  
  // Wildcard Powers
  WILDCARD_ACTIVATE: 'sfx_wildcard_activate',
  WILDCARD_EVOLVE: 'sfx_wildcard_evolve',
  ESSENCE_CONSUME: 'sfx_essence_consume',
  ESSENCE_UNLOCK: 'sfx_essence_unlock',
  
  // Quests
  QUEST_COMPLETE: 'sfx_quest_complete',
  QUEST_PROGRESS: 'sfx_quest_progress',
  QUEST_NEW: 'sfx_quest_new',
  
  // Ship Repair/Healing
  SHIP_REPAIR: 'sfx_ship_repair',
  HEAL_APPLY: 'sfx_heal_apply',
  
  // Consumables/Hotbar
  ITEM_USE: 'sfx_item_use',
  
  // Buffs/Debuffs
  BUFF_APPLY: 'sfx_buff_apply',
  DEBUFF_APPLY: 'sfx_debuff_apply',
  
  // Crew
  CREW_RECRUIT: 'sfx_crew_recruit',
  
  // Territory
  TERRITORY_CLAIM: 'sfx_territory_claim',
  
  // Sprint
  SPRINT_START: 'sfx_sprint_start',
  SPRINT_START_1: 'sfx_sprint_start_1',
  SPRINT_START_2: 'sfx_sprint_start_2',
  SPRINT_START_3: 'sfx_sprint_start_3',
  
  // UI
  UI_CLICK: 'sfx_ui_click',
  UI_HOVER: 'sfx_ui_hover',
  UI_OPEN: 'sfx_ui_open',
  UI_CLOSE: 'sfx_ui_close',
  UI_ERROR: 'sfx_ui_error',
  UI_OPEN_TERRITORY_CLAIM: 'sfx_ui_open_territory_claim',
  
  // Research/Identify (Diablo/PoE/Tarkov style)
  RESEARCH_START: 'sfx_research_start',
  RESEARCH_PROGRESS: 'sfx_research_progress',
  RESEARCH_COMPLETE: 'sfx_research_complete',
  RESEARCH_ERROR: 'sfx_research_error',
  IDENTIFY_ITEM: 'sfx_identify_item',
  
  // Navigation
  SHIP_MOVE: 'sfx_ship_move',
  ANCHOR_DROP: 'sfx_anchor_drop',
  ANCHOR_RAISE: 'sfx_anchor_raise',
  DOCK_ARRIVE: 'sfx_dock_arrive',

  // Instances
  WHIRLPOOL_ENTER: 'sfx_whirlpool_enter',
  WHIRLPOOL_EXIT: 'sfx_whirlpool_exit',
  RIFT_ENTER: 'sfx_rift_enter',
  RIFT_EXIT: 'sfx_rift_exit',
  SANCTUM_ENTER: 'sfx_sanctum_enter',
  SANCTUM_EXIT: 'sfx_sanctum_exit',
  SANCTUM_ROOM_CLEAR: 'sfx_sanctum_room_clear',
  SANCTUM_BOSS_SPAWN: 'sfx_sanctum_boss_spawn',
  SANCTUM_BOSS_DEATH: 'sfx_sanctum_boss_death',

  // Loot
  LOOT_OPEN: 'sfx_loot_open',
  LOOT_COLLECT_1: 'sfx_loot_collect_1',
  LOOT_COLLECT_2: 'sfx_loot_collect_2',

  // Harvesting
  HARVEST_START: 'sfx_harvest_start',
  
  // Construction
  CONSTRUCTION_PLACE: 'sfx_construction_place',
  CONSTRUCTION_REMOVE: 'sfx_construction_remove',
  HARVEST_TICK_LOOP: 'sfx_harvest_tick_loop',
  HARVEST_COMPLETE: 'sfx_harvest_complete',

  // Ship ambience
  SHIP_SAIL_LOOP_1: 'sfx_ship_sail_loop_1',
  SHIP_SAIL_LOOP_2: 'sfx_ship_sail_loop_2',
  SHIP_CREAK_1: 'sfx_ship_creak_1',
  SHIP_CREAK_2: 'sfx_ship_creak_2',
  FIRE_EXTINGUISH: 'sfx_fire_extinguish',
  
  // World events
  DON: 'sfx_don',

  // Rift Storm ambient
  STORM_1: 'sfx_storm_1',
  STORM_2: 'sfx_storm_2',
  STORM_3: 'sfx_storm_3',
  STORM_4: 'sfx_storm_4',

  // Background music
  GL_BACKGROUND: 'sfx_gl_background',
  
  // Ambient (optional, can be looped)
  OCEAN_WAVES: 'sfx_ocean_waves',
  SEAGULLS: 'sfx_seagulls',
} as const;

export type SfxKey = typeof SFX_KEYS[keyof typeof SFX_KEYS];

// ============ SOUND CONFIG ============

interface SoundConfig {
  key: SfxKey;
  path: string;
  volume?: number;
  loop?: boolean;
}

// Only configure sounds that have actual audio files
// Comment out entries for sounds that don't exist yet to prevent load errors
const SOUND_CONFIGS: SoundConfig[] = [
  // Combat
  { key: SFX_KEYS.CANNON_FIRE, path: 'sfx/sfx_cannon_fire.mp3', volume: 0.6 },
  { key: SFX_KEYS.CANNON_FIRE_1, path: 'sfx/sfx_cannon_fire_1.mp3', volume: 0.6 },
  { key: SFX_KEYS.CANNON_FIRE_2, path: 'sfx/sfx_cannon_fire_2.mp3', volume: 0.6 },
  { key: SFX_KEYS.CANNON_FIRE_3, path: 'sfx/sfx_cannon_fire_3.mp3', volume: 0.6 },
  { key: SFX_KEYS.CANNON_HIT, path: 'sfx/sfx_cannon_hit.mp3', volume: 0.5 },
  { key: SFX_KEYS.CANNON_HIT_1, path: 'sfx/sfx_cannon_hit_1.mp3', volume: 0.5 },
  { key: SFX_KEYS.CANNON_HIT_2, path: 'sfx/sfx_cannon_hit_2.mp3', volume: 0.5 },
  { key: SFX_KEYS.CANNON_MISS, path: 'sfx/sfx_cannon_miss.mp3', volume: 0.3 },
  { key: SFX_KEYS.CANNON_MISS_WATER_1, path: 'sfx/sfx_cannon_miss_water_1.mp3', volume: 0.3 },
  { key: SFX_KEYS.CANNON_MISS_WATER_2, path: 'sfx/sfx_cannon_miss_water_2.mp3', volume: 0.3 },
  { key: SFX_KEYS.CANNON_CRIT, path: 'sfx/sfx_cannon_crit.mp3', volume: 0.7 },
  { key: SFX_KEYS.CANNON_CRIT_1, path: 'sfx/sfx_cannon_crit_1.mp3', volume: 0.7 },
  { key: SFX_KEYS.CANNON_CRIT_2, path: 'sfx/sfx_cannon_crit_2.mp3', volume: 0.7 },
  { key: SFX_KEYS.SHIP_SINKING, path: 'sfx/sfx_ship_sinking.mp3', volume: 0.6 },
  { key: SFX_KEYS.SHIP_EXPLOSION, path: 'sfx/sfx_ship_explosion.mp3', volume: 0.7 },
  { key: SFX_KEYS.SHIP_ON_FIRE_LOOP, path: 'sfx/sfx_ship_on_fire_loop.mp3', volume: 0.25, loop: true },

  // Sanctum
  { key: SFX_KEYS.SANCTUM_COMBAT_1, path: 'sfx/sfx_sanctumcombat_1.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_COMBAT_2, path: 'sfx/sfx_sanctumcombat_2.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_COMBAT_3, path: 'sfx/sfx_sanctumcombat_3.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_TERMINAL, path: 'sfx/sfx_sanctumterminal.mp3', volume: 0.55 },
  
  // Fishing
  { key: SFX_KEYS.FISHING_CAST, path: 'sfx/sfx_fishing_cast.mp3', volume: 0.4 },
  { key: SFX_KEYS.FISHING_CATCH, path: 'sfx/sfx_fishing_catch.mp3', volume: 0.5 },
  { key: SFX_KEYS.FISHING_RARE_CATCH, path: 'sfx/sfx_fishing_rare_catch.mp3', volume: 0.7 },
  { key: SFX_KEYS.FISHING_NO_CATCH, path: 'sfx/sfx_fishing_no_catch.mp3', volume: 0.3 },
  
  // Economy
  { key: SFX_KEYS.COINS_GAIN, path: 'sfx/sfx_coins_gain.mp3', volume: 0.5 },
  { key: SFX_KEYS.COINS_GAIN_1, path: 'sfx/sfx_coins_gain_1.mp3', volume: 0.5 },
  { key: SFX_KEYS.COINS_GAIN_2, path: 'sfx/sfx_coins_gain_2.mp3', volume: 0.5 },
  { key: SFX_KEYS.COINS_GAIN_3, path: 'sfx/sfx_coins_gain_3.mp3', volume: 0.5 },
  { key: SFX_KEYS.COINS_SPEND, path: 'sfx/sfx_coins_spend.mp3', volume: 0.4 },
  { key: SFX_KEYS.COINS_SPEND_1, path: 'sfx/sfx_coins_spend_1.mp3', volume: 0.4 },
  { key: SFX_KEYS.COINS_SPEND_2, path: 'sfx/sfx_coins_spend_2.mp3', volume: 0.4 },
  { key: SFX_KEYS.ITEM_PICKUP, path: 'sfx/sfx_item_pickup.mp3', volume: 0.4 },
  { key: SFX_KEYS.ITEM_EQUIP, path: 'sfx/sfx_item_equip.mp3', volume: 0.5 },
  { key: SFX_KEYS.SHOP_OPEN, path: 'sfx/sfx_shop_open.mp3', volume: 0.4 },
  { key: SFX_KEYS.SHOP_PURCHASE, path: 'sfx/sfx_shop_purchase.mp3', volume: 0.5 },
  
  // Progression
  { key: SFX_KEYS.LEVEL_UP, path: 'sfx/sfx_level_up.mp3', volume: 0.8 },
  { key: SFX_KEYS.XP_GAIN, path: 'sfx/sfx_xp_gain.mp3', volume: 0.35 },

  // Crafting
  { key: SFX_KEYS.CRAFT_1, path: 'sfx/sfx_craft_1.mp3', volume: 0.55 },
  { key: SFX_KEYS.CRAFT_2, path: 'sfx/sfx_craft_2.mp3', volume: 0.55 },
  { key: SFX_KEYS.CRAFT_3, path: 'sfx/sfx_craft_3.mp3', volume: 0.55 },
  
  // Wildcard Powers
  { key: SFX_KEYS.WILDCARD_ACTIVATE, path: 'sfx/sfx_wildcard_activate.mp3', volume: 0.7 },
  { key: SFX_KEYS.WILDCARD_EVOLVE, path: 'sfx/sfx_wildcard_evolve.mp3', volume: 0.8 },
  { key: SFX_KEYS.ESSENCE_CONSUME, path: 'sfx/sfx_essence_consume.mp3', volume: 0.5 },
  { key: SFX_KEYS.ESSENCE_UNLOCK, path: 'sfx/sfx_essence_unlock.mp3', volume: 0.6 },
  
  // Quests
  { key: SFX_KEYS.QUEST_COMPLETE, path: 'sfx/sfx_quest_complete.mp3', volume: 0.7 },
  // { key: SFX_KEYS.QUEST_PROGRESS, path: 'sfx/sfx_quest_progress.mp3', volume: 0.3 }, // No file yet
  // { key: SFX_KEYS.QUEST_NEW, path: 'sfx/sfx_quest_new.mp3', volume: 0.4 }, // No file yet
  
  // Ship Repair/Healing
  { key: SFX_KEYS.SHIP_REPAIR, path: 'sfx/sfx_ship_repair.mp3', volume: 0.5 },
  { key: SFX_KEYS.HEAL_APPLY, path: 'sfx/sfx_heal_apply.mp3', volume: 0.4 },
  
  // Consumables/Hotbar
  { key: SFX_KEYS.ITEM_USE, path: 'sfx/sfx_item_use.mp3', volume: 0.4 },
  
  // Buffs/Debuffs
  { key: SFX_KEYS.BUFF_APPLY, path: 'sfx/sfx_buff_apply.mp3', volume: 0.3 },
  { key: SFX_KEYS.DEBUFF_APPLY, path: 'sfx/sfx_debuff_apply.mp3', volume: 0.3 },
  
  // Crew
  { key: SFX_KEYS.CREW_RECRUIT, path: 'sfx/sfx_crew_recruit.mp3', volume: 0.5 },
  
  // Territory
  { key: SFX_KEYS.TERRITORY_CLAIM, path: 'sfx/sfx_territory_claim.mp3', volume: 0.6 },
  
  // Sprint (multiple variants for variety)
  { key: SFX_KEYS.SPRINT_START_1, path: 'sfx/sfx_sprint_start_1.mp3', volume: 0.3 },
  { key: SFX_KEYS.SPRINT_START_2, path: 'sfx/sfx_sprint_start_2.mp3', volume: 0.3 },
  { key: SFX_KEYS.SPRINT_START_3, path: 'sfx/sfx_sprint_start_3.mp3', volume: 0.3 },
  
  // UI - No files yet
  { key: SFX_KEYS.UI_CLICK, path: 'sfx/sfx_ui_click.mp3', volume: 0.3 },
  { key: SFX_KEYS.UI_OPEN, path: 'sfx/sfx_ui_open.mp3', volume: 0.35 },
  { key: SFX_KEYS.UI_CLOSE, path: 'sfx/sfx_ui_close.mp3', volume: 0.3 },
  { key: SFX_KEYS.UI_ERROR, path: 'sfx/sfx_ui_error.mp3', volume: 0.35 },
  { key: SFX_KEYS.UI_OPEN_TERRITORY_CLAIM, path: 'sfx/sfx_ui_open_territory_claim.mp3', volume: 0.35 },
  
  // Research/Identify
  { key: SFX_KEYS.RESEARCH_START, path: 'sfx/sfx_research_start.mp3', volume: 0.5 },
  { key: SFX_KEYS.RESEARCH_PROGRESS, path: 'sfx/sfx_research_progress.mp3', volume: 0.3 },
  { key: SFX_KEYS.RESEARCH_COMPLETE, path: 'sfx/sfx_research_complete.mp3', volume: 0.6 },
  { key: SFX_KEYS.RESEARCH_ERROR, path: 'sfx/sfx_research_error.mp3', volume: 0.45 },
  { key: SFX_KEYS.IDENTIFY_ITEM, path: 'sfx/sfx_identify_item.mp3', volume: 0.5 },
  
  // Navigation
  // { key: SFX_KEYS.SHIP_MOVE, path: 'sfx/sfx_ship_move.mp3', volume: 0.2 }, // No file yet
  // { key: SFX_KEYS.ANCHOR_DROP, path: 'sfx/sfx_anchor_drop.mp3', volume: 0.5 }, // No file yet
  { key: SFX_KEYS.ANCHOR_RAISE, path: 'sfx/sfx_anchor_raise.mp3', volume: 0.45 },
  { key: SFX_KEYS.DOCK_ARRIVE, path: 'sfx/sfx_dock_arrive.mp3', volume: 0.4 },

  { key: SFX_KEYS.WHIRLPOOL_ENTER, path: 'sfx/sfx_whirlpool_enter.mp3', volume: 0.55 },
  { key: SFX_KEYS.WHIRLPOOL_EXIT, path: 'sfx/sfx_whirlpool_exit.mp3', volume: 0.55 },
  { key: SFX_KEYS.RIFT_ENTER, path: 'sfx/sfx_rift_enter.mp3', volume: 0.55 },
  { key: SFX_KEYS.RIFT_EXIT, path: 'sfx/sfx_rift_exit.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_ENTER, path: 'sfx/sfx_sanctum_enter.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_EXIT, path: 'sfx/sfx_sanctum_exit.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_ROOM_CLEAR, path: 'sfx/sfx_sanctum_room_clear.mp3', volume: 0.55 },
  { key: SFX_KEYS.SANCTUM_BOSS_SPAWN, path: 'sfx/sfx_sanctum_boss_spawn.mp3', volume: 0.6 },
  { key: SFX_KEYS.SANCTUM_BOSS_DEATH, path: 'sfx/sfx_sanctum_boss_death.mp3', volume: 0.6 },

  { key: SFX_KEYS.LOOT_OPEN, path: 'sfx/sfx_loot_open.mp3', volume: 0.45 },
  { key: SFX_KEYS.LOOT_COLLECT_1, path: 'sfx/sfx_loot_collect_1.mp3', volume: 0.35 },
  { key: SFX_KEYS.LOOT_COLLECT_2, path: 'sfx/sfx_loot_collect_2.mp3', volume: 0.35 },

  { key: SFX_KEYS.HARVEST_START, path: 'sfx/sfx_harvest_start.mp3', volume: 0.45 },
  { key: SFX_KEYS.HARVEST_TICK_LOOP, path: 'sfx/sfx_harvest_tick_loop.mp3', volume: 0.22, loop: true },
  { key: SFX_KEYS.HARVEST_COMPLETE, path: 'sfx/sfx_harvest_complete.mp3', volume: 0.5 },

  { key: SFX_KEYS.SHIP_SAIL_LOOP_1, path: 'sfx/sfx_ship_sail_loop_1.mp3', volume: 0.16, loop: true },
  { key: SFX_KEYS.SHIP_SAIL_LOOP_2, path: 'sfx/sfx_ship_sail_loop_2.mp3', volume: 0.16, loop: true },
  { key: SFX_KEYS.SHIP_CREAK_1, path: 'sfx/sfx_ship_creak_1.mp3', volume: 0.25 },
  { key: SFX_KEYS.SHIP_CREAK_2, path: 'sfx/sfx_ship_creak_2.mp3', volume: 0.25 },
  { key: SFX_KEYS.FIRE_EXTINGUISH, path: 'sfx/sfx_fire_extinguish.mp3', volume: 0.45 },

  // World events
  { key: SFX_KEYS.DON, path: 'sfx/sfx_don.mp3', volume: 0.65 },

  // Rift Storm ambient
  { key: SFX_KEYS.STORM_1, path: 'sfx/storm/sfx_storm_1.mp3', volume: 0.25 },
  { key: SFX_KEYS.STORM_2, path: 'sfx/storm/sfx_storm_2.mp3', volume: 0.25 },
  { key: SFX_KEYS.STORM_3, path: 'sfx/storm/sfx_storm_3.mp3', volume: 0.25 },
  { key: SFX_KEYS.STORM_4, path: 'sfx/storm/sfx_storm_4.mp3', volume: 0.25 },

  // Background music
  { key: SFX_KEYS.GL_BACKGROUND, path: 'sfx/sfx_gl_background.mp3', volume: 0.2, loop: true },
  
  // Ambient - No files yet
  // { key: SFX_KEYS.OCEAN_WAVES, path: 'sfx/sfx_ocean_waves.mp3', volume: 0.2, loop: true },
  // { key: SFX_KEYS.SEAGULLS, path: 'sfx/sfx_seagulls.mp3', volume: 0.15, loop: true },
];

// ============ SOUND MANAGER ============

export class SoundManager {
  private scene: Phaser.Scene;
  private sounds: Map<SfxKey, Phaser.Sound.BaseSound> = new Map();
  private configs: Map<SfxKey, SoundConfig> = new Map();
  private masterVolume: number = 1.0;
  private sfxVolume: number = 1.0;
  private musicVolume: number = 1.0;
  private sfxEnabled: boolean = true;
  private musicEnabled: boolean = true;
  private backgroundMusicKey: SfxKey | null = null;
  private loadedKeys: Set<SfxKey> = new Set();
  private lastPlayTime: Map<SfxKey, number> = new Map();
  private minPlayInterval: number = 100; // Minimum ms between same sound plays

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    
    // Build config map
    for (const config of SOUND_CONFIGS) {
      this.configs.set(config.key, config);
    }
  }
  
  getMasterVolume(): number {
    return this.masterVolume;
  }

  getSfxVolume(): number {
    return this.sfxVolume;
  }

  getMusicVolume(): number {
    return this.musicVolume;
  }

  // Track which sounds failed to load
  private static failedLoads: Set<string> = new Set();

  /**
   * Preload all sound assets - call this in scene.preload()
   * Silently handles missing/invalid audio files
   */
  static preloadSounds(scene: Phaser.Scene): void {
    // Clear failed loads from previous attempts
    SoundManager.failedLoads.clear();
    
    // Set up error handler to catch failed audio loads
    scene.load.on('loaderror', (file: Phaser.Loader.File) => {
      if (file.type === 'audio') {
        SoundManager.failedLoads.add(file.key);
        // Silently track - don't spam console
      }
    });
    
    // Load all configured sounds
    for (const config of SOUND_CONFIGS) {
      scene.load.audio(config.key, `/assets/${config.path}`);
    }
  }

  /**
   * Initialize sounds after preload - call this in scene.create()
   */
  initializeSounds(): void {
    let loadedCount = 0;
    let skippedCount = 0;
    
    for (const config of SOUND_CONFIGS) {
      // Skip sounds that failed to load
      if (SoundManager.failedLoads.has(config.key)) {
        skippedCount++;
        continue;
      }
      
      // Check if the audio was actually loaded and is valid
      if (this.scene.cache.audio.exists(config.key)) {
        try {
          const isMusic = config.key === SFX_KEYS.GL_BACKGROUND;
          const volumeMultiplier = isMusic ? this.musicVolume : this.sfxVolume;
          const sound = this.scene.sound.add(config.key, {
            volume: (config.volume ?? 1.0) * this.masterVolume * volumeMultiplier,
            loop: config.loop ?? false,
          });
          this.sounds.set(config.key, sound);
          this.loadedKeys.add(config.key);
          loadedCount++;
        } catch {
          // Sound data exists but is invalid/empty
          skippedCount++;
        }
      } else {
        skippedCount++;
      }
    }
    
    if (loadedCount > 0) {
      console.log(`🔊 SoundManager: ${loadedCount} sounds loaded, ${skippedCount} skipped (no audio files yet)`);
    }
  }

  /**
   * Play a sound effect with cooldown to prevent spam
   */
  play(key: SfxKey, volumeOverride?: number): void {
    if (!this.sfxEnabled) return;
    if (!this.loadedKeys.has(key)) return;
    
    // Check cooldown to prevent sound spam
    const now = Date.now();
    const lastPlay = this.lastPlayTime.get(key) || 0;
    if (now - lastPlay < this.minPlayInterval) {
      return; // Too soon, skip this play
    }
    this.lastPlayTime.set(key, now);
    
    const sound = this.sounds.get(key);
    if (sound) {
      const config = this.configs.get(key);
      const volume = volumeOverride ?? (config?.volume ?? 1.0);
      
      // For non-looping sounds, play fresh each time
      if (!config?.loop) {
        sound.play({ volume: volume * this.masterVolume * this.sfxVolume });
      } else {
        // For looping sounds, only play if not already playing
        if (!sound.isPlaying) {
          sound.play({ volume: volume * this.masterVolume * this.sfxVolume });
        }
      }
    }
    // Sound not loaded - silently ignore (asset not provided yet)
  }

  playSpatial(
    key: SfxKey,
    sourcePosition: { x: number; y: number },
    listenerPosition: { x: number; y: number },
    baseVolume: number,
    maxDistancePx: number = 1200,
    rolloff: number = 1.5,
  ): void {
    const dx: number = sourcePosition.x - listenerPosition.x;
    const dy: number = sourcePosition.y - listenerPosition.y;
    const distancePx: number = Math.sqrt((dx * dx) + (dy * dy));

    if (distancePx >= maxDistancePx) {
      return;
    }

    const normalized: number = Math.max(0, Math.min(1, distancePx / maxDistancePx));
    const attenuation: number = Math.pow(1 - normalized, rolloff);
    const finalVolume: number = baseVolume * attenuation;

    if (finalVolume <= 0.01) {
      return;
    }

    this.play(key, finalVolume);
  }

  /**
   * Stop a looping sound
   */
  stop(key: SfxKey): void {
    const sound = this.sounds.get(key);
    if (sound && sound.isPlaying) {
      sound.stop();
    }
  }

  /**
   * Set master volume (0.0 - 1.0)
   */
  setMasterVolume(volume: number): void {
    this.masterVolume = Math.max(0, Math.min(1, volume));

    // Apply immediately via Phaser's global sound manager volume.
    // This covers one-shot sounds triggered via scene.sound.play().
    this.scene.sound.volume = this.masterVolume;

    // Also update any looping sounds we've created/stored via scene.sound.add().
    // Those keep their own volume once playing.
    this.sounds.forEach((sound, key) => {
      const config = this.configs.get(key);
      const baseVolume = config?.volume ?? 1.0;
      const isMusic = key === SFX_KEYS.GL_BACKGROUND;
      const volumeMultiplier = isMusic ? this.musicVolume : this.sfxVolume;
      const nextVolume: number = baseVolume * this.masterVolume * volumeMultiplier;
      const maybeSound = sound as unknown as { setVolume?: (volume: number) => unknown; volume?: number };
      if (typeof maybeSound.setVolume === 'function') {
        maybeSound.setVolume(nextVolume);
      } else {
        maybeSound.volume = nextVolume;
      }
    });
  }

  /**
   * Set SFX volume separately (0.0 - 1.0)
   */
  setSfxVolume(volume: number): void {
    this.sfxVolume = Math.max(0, Math.min(1, volume));
    
    // Update all SFX sounds (non-background music)
    this.sounds.forEach((sound, key) => {
      if (key !== SFX_KEYS.GL_BACKGROUND) {
        const config = this.configs.get(key);
        const baseVolume = config?.volume ?? 1.0;
        const nextVolume: number = baseVolume * this.masterVolume * this.sfxVolume;
        const maybeSound = sound as unknown as { setVolume?: (volume: number) => unknown; volume?: number };
        if (typeof maybeSound.setVolume === 'function') {
          maybeSound.setVolume(nextVolume);
        } else {
          maybeSound.volume = nextVolume;
        }
      }
    });
  }

  /**
   * Set music volume separately (0.0 - 1.0)
   */
  setMusicVolume(volume: number): void {
    this.musicVolume = Math.max(0, Math.min(1, volume));
    
    // Update background music sound
    const musicSound = this.sounds.get(SFX_KEYS.GL_BACKGROUND);
    if (musicSound) {
      const config = this.configs.get(SFX_KEYS.GL_BACKGROUND);
      const baseVolume = config?.volume ?? 1.0;
      const nextVolume: number = baseVolume * this.masterVolume * this.musicVolume;
      const maybeSound = musicSound as unknown as { setVolume?: (volume: number) => unknown; volume?: number };
      if (typeof maybeSound.setVolume === 'function') {
        maybeSound.setVolume(nextVolume);
      } else {
        maybeSound.volume = nextVolume;
      }
    }
  }

  setMusicEnabled(enabled: boolean): void {
    this.musicEnabled = enabled;
    if (!enabled) {
      this.stopBackgroundMusic();
    } else {
      this.startBackgroundMusic();
    }
  }

  isMusicEnabled(): boolean {
    return this.musicEnabled;
  }

  startBackgroundMusic(): void {
    this.backgroundMusicKey = SFX_KEYS.GL_BACKGROUND;
    if (!this.musicEnabled) return;
    if (!this.loadedKeys.has(this.backgroundMusicKey)) return;
    this.play(this.backgroundMusicKey);
  }

  stopBackgroundMusic(): void {
    if (!this.backgroundMusicKey) return;
    this.stop(this.backgroundMusicKey);
  }

  /**
   * Toggle SFX on/off
   */
  setSfxEnabled(enabled: boolean): void {
    this.sfxEnabled = enabled;
    
    if (!enabled) {
      // Stop all playing sounds
      this.sounds.forEach((sound) => {
        if (sound.isPlaying) {
          sound.stop();
        }
      });
    }
  }

  /**
   * Check if SFX is enabled
   */
  isSfxEnabled(): boolean {
    return this.sfxEnabled;
  }

  /**
   * Get list of missing sound files (for debugging)
   */
  getMissingSounds(): string[] {
    const missing: string[] = [];
    for (const config of SOUND_CONFIGS) {
      if (!this.loadedKeys.has(config.key)) {
        missing.push(config.path);
      }
    }
    return missing;
  }
}

// ============ SINGLETON ACCESS ============

let globalSoundManager: SoundManager | null = null;

const getPersistedBackgroundMusicEnabled = (): boolean => {
  try {
    const saved: string | null = localStorage.getItem('backgroundMusicEnabled');
    if (saved === null) return true;
    return saved === 'true';
  } catch {
    return true;
  }
};

const getPersistedMasterVolume = (): number => {
  try {
    const saved: string | null = localStorage.getItem('masterVolume');
    if (saved === null) return 1.0;
    const parsed = Number(saved);
    if (!Number.isFinite(parsed)) return 1.0;
    return Math.max(0, Math.min(1, parsed));
  } catch {
    return 1.0;
  }
};

const getPersistedSfxVolume = (): number => {
  try {
    const saved: string | null = localStorage.getItem('sfxVolume');
    if (saved === null) return 1.0;
    const parsed = Number(saved);
    if (!Number.isFinite(parsed)) return 1.0;
    return Math.max(0, Math.min(1, parsed));
  } catch {
    return 1.0;
  }
};

const getPersistedMusicVolume = (): number => {
  try {
    const saved: string | null = localStorage.getItem('musicVolume');
    if (saved === null) return 1.0;
    const parsed = Number(saved);
    if (!Number.isFinite(parsed)) return 1.0;
    return Math.max(0, Math.min(1, parsed));
  } catch {
    return 1.0;
  }
};

export const initGlobalSoundManager = (scene: Phaser.Scene): SoundManager => {
  globalSoundManager = new SoundManager(scene);
  globalSoundManager.setMasterVolume(getPersistedMasterVolume());
  globalSoundManager.setSfxVolume(getPersistedSfxVolume());
  globalSoundManager.setMusicVolume(getPersistedMusicVolume());
  globalSoundManager.setMusicEnabled(getPersistedBackgroundMusicEnabled());
  globalSoundManager.initializeSounds();
  return globalSoundManager;
};

export const getSoundManager = (): SoundManager | null => {
  return globalSoundManager;
};

export const playSound = (key: SfxKey, volume?: number): void => {
  globalSoundManager?.play(key, volume);
};

export const playSpatialSound = (
  key: SfxKey,
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number,
  maxDistancePx: number = 1200,
  rolloff: number = 1.5,
): void => {
  globalSoundManager?.playSpatial(key, sourcePosition, listenerPosition, baseVolume, maxDistancePx, rolloff);
};

export const playRandomCraftSound = (): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.CRAFT_1,
    SFX_KEYS.CRAFT_2,
    SFX_KEYS.CRAFT_3,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];
  playSound(randomVariant);
};

export const playRandomCoinsGainSound = (): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.COINS_GAIN_1,
    SFX_KEYS.COINS_GAIN_2,
    SFX_KEYS.COINS_GAIN_3,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];
  playSound(randomVariant);
};

export const playRandomCoinsSpendSound = (): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.COINS_SPEND_1,
    SFX_KEYS.COINS_SPEND_2,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];
  playSound(randomVariant);
};

export const playRandomLootCollectSound = (): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.LOOT_COLLECT_1,
    SFX_KEYS.LOOT_COLLECT_2,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];
  playSound(randomVariant);
};

export const playRandomCannonFireSound = (
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number,
  maxDistancePx: number = 900,
): void => {
  // Always play the original cannon sound (classic/impactful), then layer a variant on top.
  playSpatialSound(SFX_KEYS.CANNON_FIRE, sourcePosition, listenerPosition, baseVolume, maxDistancePx);

  const variants: SfxKey[] = [
    SFX_KEYS.CANNON_FIRE_1,
    SFX_KEYS.CANNON_FIRE_2,
    SFX_KEYS.CANNON_FIRE_3,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];

  // Keep the layer subtle so it adds texture without overpowering the base cannon.
  const layerVolume: number = baseVolume * 0.45;
  playSpatialSound(randomVariant, sourcePosition, listenerPosition, layerVolume, maxDistancePx);
};

export const playRandomCannonHitSound = (
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number,
  maxDistancePx: number = 900,
): void => {
  playSpatialSound(SFX_KEYS.CANNON_HIT, sourcePosition, listenerPosition, baseVolume, maxDistancePx);

  const variants: SfxKey[] = [
    SFX_KEYS.CANNON_HIT_1,
    SFX_KEYS.CANNON_HIT_2,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];

  const layerVolume: number = baseVolume * 0.45;
  playSpatialSound(randomVariant, sourcePosition, listenerPosition, layerVolume, maxDistancePx);
};

export const playRandomCannonCritSound = (
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number,
  maxDistancePx: number = 900,
): void => {
  playSpatialSound(SFX_KEYS.CANNON_CRIT, sourcePosition, listenerPosition, baseVolume, maxDistancePx);

  const variants: SfxKey[] = [
    SFX_KEYS.CANNON_CRIT_1,
    SFX_KEYS.CANNON_CRIT_2,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];

  const layerVolume: number = baseVolume * 0.45;
  playSpatialSound(randomVariant, sourcePosition, listenerPosition, layerVolume, maxDistancePx);
};

export const playRandomCannonMissSound = (
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number,
  maxDistancePx: number = 900,
): void => {
  playSpatialSound(SFX_KEYS.CANNON_MISS, sourcePosition, listenerPosition, baseVolume, maxDistancePx);

  const variants: SfxKey[] = [
    SFX_KEYS.CANNON_MISS_WATER_1,
    SFX_KEYS.CANNON_MISS_WATER_2,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];

  const layerVolume: number = baseVolume * 0.45;
  playSpatialSound(randomVariant, sourcePosition, listenerPosition, layerVolume, maxDistancePx);
};

export const playRandomSanctumCombatSound = (
  sourcePosition: { x: number; y: number },
  listenerPosition: { x: number; y: number },
  baseVolume: number = 0.55,
  maxDistancePx: number = 700,
): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.SANCTUM_COMBAT_1,
    SFX_KEYS.SANCTUM_COMBAT_2,
    SFX_KEYS.SANCTUM_COMBAT_3,
  ];
  const randomVariant: SfxKey = variants[Math.floor(Math.random() * variants.length)];
  playSpatialSound(randomVariant, sourcePosition, listenerPosition, baseVolume, maxDistancePx);
};

export const playSanctumTerminalSound = (): void => {
  playSound(SFX_KEYS.SANCTUM_TERMINAL);
};

/**
 * Play a random sprint start sound variant
 */
export const playSprintStartSound = (): void => {
  const variants: SfxKey[] = [
    SFX_KEYS.SPRINT_START_1,
    SFX_KEYS.SPRINT_START_2,
    SFX_KEYS.SPRINT_START_3,
  ];
  const randomVariant = variants[Math.floor(Math.random() * variants.length)];
  playSound(randomVariant);
};

export const startBackgroundMusic = (): void => {
  globalSoundManager?.startBackgroundMusic();
};

export const stopBackgroundMusic = (): void => {
  globalSoundManager?.stopBackgroundMusic();
};

export const setMusicEnabled = (enabled: boolean): void => {
  globalSoundManager?.setMusicEnabled(enabled);
};

export const isMusicEnabled = (): boolean => {
  return globalSoundManager?.isMusicEnabled() ?? true;
};
